export const getNumberPostFix = (num: number | string) => {
  const strNum = num.toString();
  const lastDigit = strNum.substr(strNum.length - 1);
  const secondLastDigit = strNum.substr(strNum.length - 2, 1);

  if (strNum.length >= 2 && secondLastDigit === "1") {
    return "th";
  }

  switch (lastDigit) {
    case "1":
      return "st";
    case "2":
      return "nd";
    case "3":
      return "rd";
    default:
      return "th";
  }
};
